module.exports = __webpack_public_path__ + "static/media/PNB.54200e8a.txt";